import { useTranslation } from '@pancakeswap/localization'
import { Token } from '@pancakeswap/sdk'
import orderBy from 'lodash/orderBy'
import times from 'lodash/times'
import { useEffect, useState } from 'react'
import { getBetLeaderboard } from 'state/predictions/helpers'
import { Bet, PredictionUser } from 'state/types'
import styled from 'styled-components'
import InfoTooltip from '@pancakeswap/uikit/src/components/Timeline/InfoTooltip'
import PositionLabel from './PositionLabel'
import { NetWinningsView } from './Results/styles'

interface PreviousBetsTableProps {
  numberOfBets?: number
  account: string
  token: Token
  api: string
}

const PreviousBetsTable: React.FC<React.PropsWithChildren<PreviousBetsTableProps>> = ({
  numberOfBets = 5,
  account,
  token,
  api,
}) => {
  const [isFetching, setIsFetching] = useState(false)
  const [betsLeaderboard, setBetsLeaderboard] = useState<PredictionUser>()
  const { t } = useTranslation()
  // const orderedBets = orderBy(betsLeaderboard?.bets, ['round.epoch'], ['desc'])

  useEffect(() => {
    const fetchBetHistory = async () => {
      setIsFetching(true)
      try {
        const response = await getBetLeaderboard(
          {
            id: account.toLowerCase(),
          },
          numberOfBets,
          undefined,
          api,
          token.symbol,
        )

        // const transformer = transformBetResponse(token.symbol)

        setBetsLeaderboard(response.users[0])
      } finally {
        setIsFetching(false)
      }
    }

    fetchBetHistory()
  }, [account, numberOfBets, setIsFetching, api, token.symbol])

  return (
    <StyleTable>
      <StyleHead>
        <div>{t('Round')}</div>
        <div>{t('Direction')}</div>
        <div className="head-winning" style={{ textAlign: 'right' }}>
          {t('PnL')}{' '}
          <InfoTooltip
            iconColor="rgba(255,255,255,0.6)"
            ml="4px"
            text="Including claimed winnings, losses, and refund amounts. Unclaimed winnings are not included."
          />{' '}
        </div>
        {/* <Th textAlign="right">{t('Winnings (%symbol%)', { symbol: token.symbol })}</Th> */}
      </StyleHead>
      <StyleBody>
        {isFetching
          ? times(numberOfBets).map((num) => (
              <StyledTr>
                <div className="skeleton-box" />

                <div className="skeleton-box" />

                <div className="skeleton-box" />
              </StyledTr>
            ))
          : betsLeaderboard?.bets?.map((bet) => {
              const isCancelled = bet.round.failed
              const isWinner = bet.position === bet.round.position
              const isProfit = isWinner && Number(bet.claimedNetETH) > 0

              // win but not claimed

              const getAmount = () => {
                if (isWinner && !bet.claimed) {
                  return null
                }

                if (bet.claimedNetETH === null && !isCancelled) {
                  return Number(bet.amount) * -1
                }

                if (isCancelled) {
                  return 0
                }

                return Number(bet.claimedNetETH)
              }

              return (
                <StyledTr key={bet.id}>
                  <div className="round">{bet.round.epoch.toLocaleString()}</div>
                  <div className="direction">
                    <PositionLabel position={bet.position} />
                  </div>
                  <div className="winning">
                    <NetWinningsView
                      token={token}
                      // amount={!isCancelled && isWinner ? bet.claimedNetBNB : bet.amount}
                      amount={getAmount()}
                      textPrefix={isCancelled ? '' : isProfit ? '+' : ''}
                      textColor={isCancelled ? 'main' : isProfit ? 'success' : 'failure'}
                      fontSize="14px"
                      fontWeight="700"
                      subFontSize="12px"
                      subFontWeight="400"
                      color="white"
                      flexDirection="column"
                      subFontColor="rgba(255, 255, 255, 0.60)"
                    />
                  </div>
                </StyledTr>
              )
            })}
      </StyleBody>
    </StyleTable>
  )
}

const StyleTable = styled.div`
  padding: 12px 16px;
  border-radius: var(--Base-Unit-S-12, 12px);
  border: 1px solid var(--Border, rgba(255, 255, 255, 0.1));
  .skeleton-box {
    display: inline-block;
    height: 1em;
    width: 100%;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    background-color: rgba(255, 255, 255, 0.05);
    color: transparent !important;

    > * {
      display: none;
    }

    &::after {
      position: absolute;
      inset: 0;
      transform: translateX(-100%);
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0,
        rgba(202, 202, 202, 0.22) 20%,
        rgba(242, 248, 246, 0.15) 60%,
        rgba(255, 255, 255, 0) 100%
      );
      animation: shimmer 2s infinite;
      content: '';
    }

    @keyframes shimmer {
      100% {
        transform: translateX(100%);
      }
    }
  }
  @media screen and (max-width: 991px) {
    width: calc(100% - 48px);
    margin-left: auto;
    margin-right: auto;
  }
  @media screen and (max-width: 700px) {
    width: calc(100% - 32px);
  }
`
const StyleHead = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  .head-winning {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  div {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    font-weight: 400;
    line-height: 140%;
  }
`
const StyleBody = styled.div`
  & > div {
    margin-top: 16px;
  }
`

const StyledTr = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  .round {
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 140%;
    color: #fff;
    display: flex;
    align-items: center;
  }
  .direction {
    @media screen and (max-width: 700px) {
      display: flex;
      align-items: center;
    }
  }
  .winning {
  }
`

export default PreviousBetsTable
